import { render } from "./PendingRequest.vue?vue&type=template&id=1ecb67f7"
import script from "./PendingRequest.vue?vue&type=script&lang=js"
export * from "./PendingRequest.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__